import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

//TODO HTTPS Validation?
import { InternalPage } from 'theSource/components';
import { MyCompanyCategory } from 'theSource/queries/useCompanyQuery/types';
import { CategoryItem } from './components';
import { BackLink } from 'enrollment/components';

export interface MyCompanyViewPageProps {
  data?: MyCompanyCategory[];
}

export const MyCompanyViewPage = ({ data }: MyCompanyViewPageProps) => {
  const { t } = useTranslation('pages.company');

  return (
    <InternalPage
      testId="my-company-view-page"
      title={t('title')}
      CustomActionComponent={<BackLink />}
      customActionAlignment="left"
    >
      <Stack spacing={6}></Stack>
      {data && data.length !== 0 ? (
        <ul>
          {data?.map((item, index) => (
            <CategoryItem
              key={index}
              title={item.name}
              locked={item.locked}
              lookupCode={item.id.toString()}
              url={item.url}
              icon={item.icon}
            />
          ))}
        </ul>
      ) : (
        <ul>
          <CategoryItem
            title="Global And Benefit Documents"
            locked={true}
            lookupCode=""
            icon="Files"
          />
        </ul>
      )}
    </InternalPage>
  );
};
